import { useCallback } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import styled from 'foundations-theming-specialty/utils';
import OverlappingIcons from './OverlappingIcons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledButton = styled.button.withConfig({
  displayName: "OverlappingIconsButton__StyledButton",
  componentId: "sc-4gzawp-0"
})(["background:", ";cursor:pointer;display:inline-block;width:fit-content;border-radius:", ";padding:", ";border-width:", ";&:hover,&:active{background:", ";}"], ({
  theme,
  selected
}) => selected ? theme.color['fill-surface-recessed'] : theme.color['fill-surface-default'], ({
  theme
}) => theme.borderRadius['400'], ({
  theme
}) => `${theme.space['0']}`, ({
  theme
}) => theme.borderWidth['0'], ({
  theme
}) => theme.color['fill-surface-recessed']);
const MAX_VISIBLE_ICONS = 3;
export const OverlappingIconsButton = ({
  icons = [],
  onClick,
  children,
  selected = false,
  // Border Style Props
  borderWidth,
  borderStyle,
  borderColor
}) => {
  const handleClick = useCallback(event => {
    onClick === null || onClick === void 0 || onClick(event);
  }, [onClick]);
  const visibleIcons = icons.slice(0, MAX_VISIBLE_ICONS);
  return /*#__PURE__*/_jsx(StyledButton, {
    onClick: handleClick,
    selected: selected,
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "200",
      paddingBlock: "100",
      paddingInline: "250",
      borderWidth: borderWidth,
      borderStyle: borderStyle,
      borderColor: borderColor,
      borderRadius: "400",
      children: [/*#__PURE__*/_jsx(OverlappingIcons, {
        icons: visibleIcons
      }), children]
    })
  });
};